import { isProd } from 'config/config';
import { getPage, getCourse, getSession, addNewStudent } from 'helpers/api';
import { getUrlParamsByName, formatDate, formatMoney } from 'helpers/utils';

const state = {
    navSet: null,
    type: null,
    requiredFields: ['Name', 'Email', 'confirm'],
    submit: document.getElementsByClassName('js--submit')[0] || null,
    message: document.getElementsByClassName('js--register-success')[0] || null,
    coursesPage: isProd ? '/portal/training-and-events' : '/training-and-events.html',
    schoolPage: isProd ? '/portal/training-and-events/update-schools' : 'update-schools.html',
    courseInfo: isProd
        ? '/portal/training-and-events/more-information'
        : '/training-more-info.html',
    schoolInfo: isProd
        ? '/portal/training-and-events/schools-more-information'
        : '/schools-more-information.html',
    courseRegister: isProd
        ? '/portal/training-and-events/pricing-and-register'
        : '/training-register.html',
    register: isProd ? '/portal/training-and-events/registered-events' : 'registered-events.html',
};

// ==================================================
// HANDLERS
// ==================================================

async function fetchAndHandleCourses() {
    const { courses } = await getPage(1, state.type);

    if (!courses.length) {
        document.getElementsByClassName('js--loading')[0].classList.add('none');
        return document.getElementsByClassName('js--no-items')[0].classList.remove('none');
    }

    document.getElementsByClassName('js--train-list')[0].innerHTML = courses
        .map((k) => card(k))
        .join('');
}

async function fetchAndHandleCourseId() {
    const res = await getCourse(getUrlParamsByName('sessionId'));

    if (res.status !== 200) {
        return;
    }

    const { Name, Description, Sessions } = res.info;
    let title = document.getElementsByClassName('js--train-title')[0] || null;
    if (title != null) {
        title.innerHTML = Name;
    }

    title = document.getElementsByClassName('js--school-title')[0] || null;
    if (title != null) {
        title.innerHTML = Name;
    }

    let body = document.getElementsByClassName('js--train-body')[0] || null;
    if (body != null) {
        body.innerHTML = Description;
    }

    body = document.getElementsByClassName('js--school-body')[0] || null;
    if (body != null) {
        body.innerHTML = Description;
    }

    if (!Sessions.length) {
        return (document.getElementsByClassName('js--no-items')[0].innerHTML =
            'No items available.');
    }

    const train = document.getElementsByClassName('js--train-list')[0] || null;
    if (train != null) {
        train.innerHTML = Sessions.map((k) => sessionCard(k)).join('');
    }

    const school = document.getElementsByClassName('js--school-list')[0] || null;
    if (school != null) {
        school.innerHTML = Sessions.map((k) => schoolSessionCard(k)).join('');
    }
}

async function fetchAndHandleSessionId() {
    state.sessionId = getUrlParamsByName('sessionId');
    const res = await getSession(state.sessionId);

    if (res.status !== 200) {
        return;
    }

    const { info } = res;

    info.StartEndTime = `${info.StartTime} - ${info.EndTime}`;
    info.CityStateZip = `${info.Address.City}, ${info.Address.State} ${info.Address.Zip}`;
    info.StartDate = formatDate(info.StartDate);
    info.EndDate = formatDate(info.EndDate);
    info.Price = formatMoney(info.Price);
    info.StreetLine1 = info.Address.StreetLine1;

    const { Description, Name } = res.info;
    Array.from([
        'StartDate',
        'EndDate',
        'StartEndTime',
        'Price',
        'StreetLine1',
        'CityStateZip',
        'AttendCopy',
    ]).forEach((k) => (document.getElementsByClassName(`js--${k}`)[0].innerHTML = info[k]));

    document.getElementsByClassName('js--train-title')[0].innerHTML = Name;
    document.getElementsByClassName('js--train-body')[0].innerHTML = Description;
    document.getElementsByClassName('js--LocationUrl')[0].setAttribute('href', info.LocationUrl);
    document.getElementsByClassName(
        'js--map',
    )[0].src = `https://www.google.com/maps/embed/v1/place?key=AIzaSyBrYqLF72Fgw5UlpZRVQJuwEm5RzJdiDK8&q=${info.StreetLine1},${info.Address.City}+${info.Address.State}`;
}

function handleFieldChange(e) {
    const field = e.target;

    state.message.classList.add('none');
    field.classList.remove('input-error');
    handleBtnEnable(e);
}

async function handleSubmit(e) {
    e.preventDefault();
    const form = document.getElementsByClassName(' js--form')[0];
    const data = new FormData(form);
    const filter = Array.from(data).filter((k) => {
        if (state.requiredFields.indexOf(k[0]) === -1) {
            return false;
        }

        return !(k[1].length > 0);
    });

    if (filter.length) {
        return displayErrors();
    }

    const postData = {};
    Array.from(data).forEach(([k1, k2]) => (postData[k1] = k2));

    state.isFetching = true;
    const res = await addNewStudent(postData, state.sessionId);
    state.isFetching = false;

    if (res.status !== 200) {
        return;
    }

    state.message.innerHTML = res.message;
    state.message.classList.remove('none');
    state.submit.classList.add('disabled');
    Array.from(document.getElementsByClassName('js--input')).forEach((k) => (k.value = ''));
}

function handleBtnEnable(e) {
    const val = e.target.value;

    if (e.keyCode === 13) {
        return val.length ? handleSubmit(e) : false;
    }

    const filtered = state.requiredFields
        .map((k) => {
            const field = document.getElementById(k);

            return field.type === 'checkbox' ? field.checked : field.value.length > 0;
        })
        .filter((k) => !k);

    const { classList } = state.submit;
    const disabledClassFound = classList.contains('disabled');

    if (!filtered.length && disabledClassFound) {
        classList.remove('disabled');
    }

    if (filtered.length && !disabledClassFound) {
        classList.add('disabled');
    }
}

function handleNav() {
    state.navSet = document.getElementsByTagName('section')[0].getAttribute('data-type');
    switch (state.navSet) {
        case 'UpdateSchool':
            document.getElementsByClassName('dashboard__subnav')[0].innerHTML = nav(
                true,
                false,
                false,
            );
            break;
        case 'Course':
            document.getElementsByClassName('dashboard__subnav')[0].innerHTML = nav(
                false,
                true,
                false,
            );
            break;
        case 'Registered':
            document.getElementsByClassName('dashboard__subnav')[0].innerHTML = nav(
                false,
                false,
                true,
            );
            break;
        default:
            break;
    }
}

// ==================================================
// HELPERS
// ==================================================

const card = ({ Name, Description, Id, Type }) => `<div class="train__container">
    <div class="train__img">
      <img class="train__img__asset" src="/assets/tools.png" alt="">
    </div>
    <div class="train__content">
      <h3 class="train__title">${Name}</h3>
      <p class="train__body">${Description}</p>
      <a href="${Type === 'UpdateSchool' ? state.schoolInfo : state.courseInfo
    }?sessionId=${Id}" class="train__link">More Information</a>
    </div>
  </div>`;

const sessionCard = ({
    StartDate,
    EndDate,
    SeatsAvailable,
    Address,
    StartTime,
    EndTime,
    Id,
}) => `<li>
  <div class="list-grid__results__item list-grid__results__item">
    <div class="list-grid__results__li list-grid__results--center" data-label="Start Date">${formatDate(
    StartDate,
)}</div>
    <div class="list-grid__results__li list-grid__results--center" data-label="End Date">${formatDate(
    EndDate,
)}</div>
    <div class="list-grid__results__li list-grid__results--center" data-label="Time">${StartTime} - ${EndTime}</div>
    <div class="list-grid__results__li list-grid__results--center" data-label="City">${Address.City
    }</div>
    <div class="list-grid__results__li  list-grid__results--center" data-label="State">${Address.State
    }</div>
    <div class="list-grid__results__li  list-grid__results--center" data-label="Seats Avail.">${SeatsAvailable}</div>
    <div class="list-grid__results__li  list-grid__results--center" data-label=" ">
      <a href="${state.courseRegister
    }?sessionId=${Id}" class="list-grid__results__link">Pricing / Register</a>
    </div>
  </div>
</li>`;

const schoolSessionCard = ({
    Name,
    Description,
    StartDate,
    EndDate,
    LocationUrl,
    Register,
    Id,
}) => `<li>
  <div class="list-grid__results__item list-grid__results__item">
  <div class="list-grid__results__li list-grid__results--center" data-label="Title">${Name}</div>
  <div class="list-grid__results__li list-grid__results--center" data-label="Description">${Description}</div>
    <div class="list-grid__results__li list-grid__results--center" data-label="Start Date">${formatDate(
    StartDate,
)}</div>
    <div class="list-grid__results__li list-grid__results--center" data-label="End Date">${formatDate(
    EndDate,
)}</div>
    <div class="list-grid__results__li  list-grid__results--center" data-label=" ">
      <a href="${Register ? state.register + '?sessionId=' + Id : LocationUrl
    }" class="list-grid__results__link">${Register ? 'Pricing / Register' : 'Webinar'}</a>
    </div>
  </div>
</li>`;

function displayErrors() {
    state.requiredFields.forEach((k) => {
        const el = document.getElementById(k);

        return k.value ? false : el.classList.add('input-error');
    });
}

const nav = (USActive = false, CActive = false, REActive = false) => `
<a href="${state.schoolPage}" class="dashboard__subnav__link ${USActive ? 'dashboard__subnav--active' : ''
    }">Update Schools</a>
<a href="${state.coursesPage}" class="dashboard__subnav__link ${CActive ? 'dashboard__subnav--active' : ''
    }">Courses</a>
<a href="${state.register}" class="dashboard__subnav__link ${REActive ? 'dashboard__subnav--active' : ''
    }">Registered Events</a>`;

// ==================================================
// INIT
// ==================================================

function init() {
    if (document.getElementsByClassName('js--training-events')[0]) {
        state.type = document.getElementsByClassName('js--train-list')[0].getAttribute('data-type');
        fetchAndHandleCourses();
    }

    if (document.getElementsByClassName('js--training-more-info')[0]) {
        fetchAndHandleCourseId();
    }

    if (document.getElementsByClassName('js--training-register')[0]) {
        fetchAndHandleSessionId();

        Array.from(document.getElementsByClassName('js--input')).forEach((k) =>
            k.addEventListener('keyup', (e) => handleFieldChange(e)),
        );

        document.getElementById('confirm').addEventListener('click', (e) => handleFieldChange(e));

        document
            .getElementsByClassName('js--form')[0]
            .addEventListener('submit', (e) => handleSubmit(e));

        state.submit.addEventListener('click', (e) => handleSubmit(e));
    }
    handleNav();
}

export default init;
